import axios from "../api/axios"; // Importing the Axios library for making HTTP requests
/**
* Handles user login by sending a POST request to the server.
* @param {string} Email - The user's email address.
*/
export const validate_user = async (email) => {
    try {
      // Send a POST request to the server with the user's email and password
      const response = await axios.post(
        "/validate_user", // The endpoint to handle user login  
          { email }, // User's email
      );
      return response; // Return the server response
    } catch (error) {
      throw error; // If an error occurs, rethrow it to be handled by the caller
    }
  };